import type { Event } from "@circle-react/types/Event";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { CompassDuplicateEventModal } from "./CompassDuplicateEventModal";
import { UIKitModal } from "./UIKitModal";

export interface DuplicateEventModalProps {
  event: Pick<Event, "id" | "name" | "slug" | "space_id">;
  onClose: () => void;
  show: boolean;
}

export const DuplicateEventModal = (props: DuplicateEventModalProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  if (isCircleV4) return <CompassDuplicateEventModal {...props} />;
  return <UIKitModal {...props} />;
};
